import React, { useEffect, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import DataContext from "../../Component/context";
const Thankyou = () => {
    const didMountRef = useRef(true);
    const { orderid } = useParams()
    const contextValues = useContext(DataContext)
    const navigate = useNavigate()
    useEffect(() => {
        if (didMountRef.current) {
            contextValues.setCartCount(0);
            setTimeout(() => {
                navigate('/home', { replace: true });
            }, 1500);
        }
        didMountRef.current = false;
    }, []);

    return (
        <>
            <Header />
            <div id="appCapsule">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className='text-center mt-5 mb-5'>
                                <img src='/img/verified.gif' className='wd-150' alt="Daadi's Kitchen"></img>
                                <h5>Thank You for Your Order!</h5>
                                <p>Your order number is <strong>{orderid}</strong></p>
                                <p>Your order has been successfully placed. We appreciate your purchase and will process it soon.</p>
                                <a href='/' className='btn btn-outline-primary btn-md ml-30'>Continue Shopping</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
export default Thankyou;
